// extracted by mini-css-extract-plugin
export default {"card":"style_card__rRdGZ","iconAwesome":"style_iconAwesome__UnpHD","text":"style_text__UOi5s"};